import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Row} from 'reactstrap';

import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import {PROXIED_MEDIABASE} from '../../../../common/constants';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './ListIcons.styles'
import { ContentCol } from '../../SystemVariables/ListVariables/ListVariables.styles';

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListIcons extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.goToInteractionEdit = this.goToInteractionEdit.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public async goToInteractionEdit(row) {
        console.log(row);
        const dest = this.props.services.currentBaseUrl + 'interactions/' + row.rowData.id
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public async interactionDelete(row) {
        console.log(row.rowData.id);

        const retVal = confirm("Do you want to continue ?");
    
        if(retVal === true) {
                  console.log('delete accepted');
                  const res = await this.props.services.adminAPI.deleteInteraction(row.rowData.id);
                  if (res.ok) {
                    const InteractionsRes = await this.props.services.adminAPI.getInteractions();
                  
                    if(InteractionsRes.ok) {
                        const interactions = InteractionsRes.data.interactions;

                        const data = this.state.data;

                        data.interactions = interactions;

                        this.setState({data});

                    }
                    
                }
                  return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public customTD = props =>{
        return (
          <td>
           
            <img width="80" src={PROXIED_MEDIABASE + "icons/" + props.rowData.filename}/>
            
          </td>
        );
    } 

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: InteractionID } } = match;

        const assetCollectionsDataKey = ["id", "Title","delete"];
        
        const assetCollectionsThead = ["ID", "Name", "View"];


        const assetCollectionsRes = await adminAPI.getIconsOverview();

        if (assetCollectionsRes.ok) {
            
            const collections = assetCollectionsRes.data.icons;

            this.setState(
                {
                     data: {
                        collections,
                        loaded: true,
                        collectionsdatakey: assetCollectionsDataKey,
                        collectionsthead: assetCollectionsThead
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
                <SortableTbl
                    tblData={data.collections}
                    tHead={data.collectionsthead}
                    dKey={data.collectionsdatakey}
                    customTd={[
                            { custd: this.customTD, keyItem: "edit", sortable: false },
                            { custd: this.customTD, keyItem: "delete", sortable: false }
                        ]}
                    defaultCSS={false}
                />

              </Content>

              
              </Wrapper>
        );

    }

}

export default withServices(ListIcons);


// WEBPACK FOOTER //
// ./src/pages/Admin/Icons/ListIcons/ListIcons.tsx